import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { driverApi } from '../services/driverApi';
import { useHybridAuth } from './useHybridAuth';
import { useUserCompanies } from './useUserCompanies';

/** One task (GET /tasks/:id): what a push's /tasks/:id opens. */
export const useTask = (taskId: string | undefined) => {
  const { getAccessTokenSilently, isAuthenticated } = useHybridAuth();
  return useQuery({
    queryKey: ['task', taskId],
    queryFn: async () => {
      driverApi.setAuthToken(await getAccessTokenSilently());
      return driverApi.getTask(taskId!);
    },
    enabled: isAuthenticated && !!taskId,
  });
};

/** Mark a task done, then refresh the task lists and the task itself. */
export const useCompleteTask = () => {
  const { getAccessTokenSilently } = useHybridAuth();
  const { selectedCompanyId } = useUserCompanies();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (taskId: string) => {
      driverApi.setAuthToken(await getAccessTokenSilently());
      return driverApi.completeTask(taskId, selectedCompanyId ?? undefined);
    },
    onSuccess: (_result, taskId) => {
      queryClient.invalidateQueries({ queryKey: ['mobile-tasks'] });
      queryClient.invalidateQueries({ queryKey: ['task', taskId] });
    },
  });
};
